 import React, { useState } from 'react'
 import { Button, Modal } from 'antd';
 import s from './Ramzlar.module.css'
 import { Card } from 'antd';
 import g from '../img/gerb.png'
 import Table from 'react-bootstrap/Table';
 const Ramzlar = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const { Meta } = Card;
   return (
     <div>
            <div className={s.menu1}>
                <h1>Государственный департамент символы</h1>
            </div>
            <div className={s.menu2}>
              <div></div>
              <div>
                <p>Республика Узбекистан</p>
                <h1>Символы Республики Узбекистан, городов и районов</h1>
              </div>  
            </div>
 
            <div className={s.menu3}> 
                <div className={s.card1}>
                      <Card className={s.card5}>
                        <div className={s.h1}>
                          <img src={g} alt="" />
                          <div>
                            <h1>GERB</h1>
                            <h1>герб принят в ****</h1>
                          </div>
                        </div>
                        <p>
                          Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                          </p>
                          
                          <button className={s.btn5} type="primary" onClick={showModal}>Более</button>
                            <Modal title="Basic Modal" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                            Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                            </Modal>
                          
                      </Card>
                </div>
                <div className={s.card1}>
                      <Card className={s.card5}>
                        <div className={s.h1}>
                          <img src={g} alt="" />
                          <div>
                            <h1>GERB</h1>
                            <h1>герб принят в ****</h1>
                          </div>
                        </div>
                        <p>
                          Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                          </p>
                         
                          <button className={s.btn5} type="primary" onClick={showModal}>Более</button>
                            <Modal title="Basic Modal" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                            Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                            </Modal>
                          
                      </Card>
                </div>
                <div className={s.card1}>
                      <Card className={s.card5}>
                        <div className={s.h1}>
                          <img src={g} alt="" />
                          <div>
                            <h1>GERB</h1>
                            <h1>герб принят в ****</h1>
                          </div>
                        </div>
                        <p>
                          Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                          </p>
                       
                          <button className={s.btn5} type="primary" onClick={showModal}>Более</button>
                            <Modal title="Basic Modal" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                            Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                            </Modal>
                          
                      </Card>
                </div>
                <div className={s.card1}>
                  <div></div>
                      <Card className={s.card5}>
                        <div className={s.h1}>
                          <img src={g} alt="" />
                          <div>
                            <h1>GERB</h1>
                            <h1>герб принят в ****</h1>
                          </div>
                        </div>
                        <p>
                          Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                          </p>
                        
                          <button className={s.btn5} type="primary" onClick={showModal}>Более</button>
                            <Modal title="Basic Modal" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                            Герб Узбекистана (узб. Государственный Герб Республики Узбекистан / Государственный Герб Республики Узбекистан) — 
                          государственный герб Республики Узбекистан. 2 июля 1992 года Олий Рада Республики Узбекистан и Олий Рада Республики 
                          Узбекистан приняли закон «О Государственном Гербе Республики Узбекистан».

                            Существует несколько вариантов нового герба государства, но окончательным гербом является первоначальный герб,
                            созданный группой богов и графики Академии богов Узбекистана. Группу возглавляет знаменитый бог Анвар Мамаджонов. 
                            Герб Узбекской ССР является очередным вариантом на основе нового герба Узбекистана. 
                            Узбекистан — одна из трех бывших республик СССР, и их новые гербы очень похожи на прежние гербы Советского Союза.
                            Остальные страны - Таджикистан (герб Таджикистана) и Беларусь (герб Беларуси). Остальные бывшие советские республики 
                            приняли эмблемы, которые полностью отличались от их прежних советских эмблем из эпоксидной смолы.

                            9 апреля 1993 года на основе Государственного герба Республики Узбекистан был принят Государственный герб Республики
                            Каракалпакстан, входящей в состав Республики Узбекистан.
                            </Modal>
                        
                      </Card>
                </div>
            </div>
            <div className={s.menu4}> 
            <div></div>
            <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Viloyatlar</th>
                    <th>Shahar</th> 
                    <th>Tuman</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Andijon</td>
                    <td>Andijon</td>
                    <td>15ta</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Buxoro</td>
                    <td>Buxoro</td>
                    <td>11ta</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Fergana</td>
                    <td>Fergana</td>
                    <td>16ta</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Jizzakh</td>
                    <td>Jizzakh</td>
                    <td>12ta</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Xorazm</td>
                    <td>Xorazm</td>
                    <td>10ta</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Namangan	</td>
                    <td>Namangan	</td>
                    <td>11ta</td>
                  </tr> 
                  <tr>
                    <td>7</td>
                    <td>Navoiy</td>
                    <td>Navoiy</td>
                    <td>9ta</td>
                  </tr> 
                  <tr>
                    <td>8</td>
                    <td>Qashqadaryo</td>
                    <td>Qarshi</td>
                    <td>14ta</td>
                  </tr> 
                  <tr>
                    <td>9</td>
                    <td>Samarkand</td>
                    <td>Samarkand</td>
                    <td>14ta</td>
                  </tr> 
                  <tr>
                    <td>10</td>
                    <td>Sirdaryo	</td>
                    <td>Sirdaryo	</td>
                    <td>9ta</td>
                  </tr> 
                  <tr>
                    <td>11</td>
                    <td>Surxondaryo</td>
                    <td>Surxondaryo</td>
                    <td>13ta</td>
                  </tr> 
                  <tr>
                    <td>12 </td>
                    <td>Toshkent</td>
                    <td>Toshkent</td>
                    <td>11ta</td>
                  </tr>
                </tbody>
              </Table>
                        
            </div>
     </div> 
   )
 }
 
 export default Ramzlar 